export const pngSource = (pathFile) => {
    // If it's already a full path (local import), return as is
    if (
        pathFile &&
        (pathFile.startsWith("/") ||
            pathFile.startsWith("data:") ||
            pathFile.includes("static"))
    ) {
        return pathFile;
    }
    // Legacy support for old API paths
    return pathFile ? `https://strapi.semantika.pl${pathFile}` : undefined;
};

export const getPNG = (imgObj, size = "medium") => {
    // Handle both old API structure and new mock structure
    const url = imgObj?.formats?.[size.toLowerCase()]?.url || imgObj?.url;
    return pngSource(url) || undefined;
};

export const getAllSizesPNG = (imgObj) => ({
    thumbnail: getPNG(imgObj, "thumbnail"),
    large: getPNG(imgObj, "large"),
    small: getPNG(imgObj, "small"),
    medium: getPNG(imgObj, "medium"),
});

export const convertToAuthor = ({ Firstname, Lastname, name, surname }) => {
    // Handle both old and new author structure
    if (name && surname) {
        return `${name} ${surname}`;
    }
    return `${Firstname} ${Lastname}`;
};

export const convertToAuthors = (authorsArray) => {
    if (!authorsArray || authorsArray.length === 0) {
        return "Redakcja";
    }

    return authorsArray.reduce((authors, author, i, arr) => {
        const authorName = convertToAuthor(author);
        if (i === arr.length - 1) {
            return `${authors}${authorName}.`;
        }
        return `${authors}${authorName}, `;
    }, ``);
};
